import { useContext } from "react";
import { Empty, Modal, Space, Table as TableAntd } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { IInvoice } from "../../../../interfaces";
import useInvoices from "./useInvoices";
import { ThemeContext } from "../../../../contexts/ThemeContext";

interface IProps {
    open: boolean;
    isLoading: boolean;
    onClose: () => void;
    invoices: IInvoice[];
}

export default function ModalInvoiceDetails({ open, onClose, isLoading, invoices }: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';
    const navigate = useNavigate();
    const { columns } = useInvoices();

    return (
        <Modal
            width={1100}
            open={open}
            title={
                <Space align="center">
                    <FileTextOutlined style={{ color: '#1677ff' }} />
                    <span style={{ fontWeight: 600 }}>Notas Fiscais Processadas</span>
                </Space>
            }
            footer={null}
            onCancel={onClose}
            centered
            bodyStyle={{ padding: '8px 0 0 0' }}
        >
            <TableAntd
                loading={isLoading}
                columns={columns}
                dataSource={invoices.map((inv) => ({
                    ...inv,
                    key: inv.id,
                }))}
                className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                rowKey="id"
                scroll={{ x: 950 }}
                onRow={(record) => ({
                    onClick: () => {
                        navigate(`/nota/detalhes/${record.id}`);
                    },
                    style: {
                        cursor: 'pointer',
                    },
                })}
                locale={{
                    emptyText: (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description="Nenhuma nota fiscal encontrada para este período."
                        />
                    ),
                }}
                pagination={{
                    pageSize: 8,
                    showSizeChanger: true,
                    pageSizeOptions: ['8', '15', '30'],
                    size: 'small',
                }}
            />
        </Modal>
    );
}

